import { useNavigate } from 'react-router-dom';

export default function Home() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-400 via-purple-500 to-pink-500">
      {/* Header Responsivo */}
      <header className="bg-white/98 backdrop-blur-lg shadow-2xl border-b-4 border-gradient-to-r from-indigo-600 to-purple-600">
        <div className="px-4 sm:px-6 lg:px-8 py-4 lg:py-6">
          <div className="flex flex-col lg:flex-row items-center justify-between space-y-4 lg:space-y-0">
            {/* Logo e Título */}
            <div className="flex flex-col sm:flex-row items-center space-y-4 sm:space-y-0 sm:space-x-6 lg:space-x-8 w-full lg:w-auto">
              <img
                src="https://static.readdy.ai/image/8fbfc975813ef59021c9f16b313e86f9/f5810bc36c96b4c4a03e9a9aa341e507.png"
                alt="Assembleia de Deus - Missão Europa"
                className="w-20 h-20 sm:w-24 sm:h-24 lg:w-32 lg:h-32 object-contain shadow-2xl rounded-2xl border-4 border-indigo-200 hover:scale-105 transition-transform duration-300"
              />
              <div className="text-center">
                <h1 className="text-xl sm:text-2xl lg:text-4xl xl:text-5xl font-bold bg-gradient-to-r from-indigo-600 via-purple-600 to-pink-600 bg-clip-text text-transparent whitespace-nowrap">
                  <span style={{ fontFamily: '"Agnes", serif' }}>IGREJA AD MISSÃO EUROPA CHURCH</span>
                </h1>
                <p className="text-sm sm:text-base lg:text-xl text-gray-700 font-semibold">Church Portugal • Bíblia Digital • Rádio 24h</p>
                <div className="flex flex-wrap justify-center gap-2 mt-2">
                  <span className="bg-gradient-to-r from-indigo-100 to-purple-100 text-indigo-700 px-2 py-1 sm:px-4 sm:py-2 rounded-full text-xs sm:text-sm font-medium">
                    📖 66 Livros da Bíblia
                  </span>
                  <span className="bg-gradient-to-r from-purple-100 to-pink-100 text-purple-700 px-2 py-1 sm:px-4 sm:py-2 rounded-full text-xs sm:text-sm font-medium">
                    📻 Rádio 24/7
                  </span>
                </div>
              </div>
            </div>
            
            {/* Navegação Responsiva */}
            <nav className="w-full lg:w-auto">
              <div className="grid grid-cols-2 sm:grid-cols-4 lg:flex lg:items-center gap-2 lg:gap-3 xl:gap-4">
                <button 
                  onClick={() => navigate('/home')}
                  className="flex items-center justify-center space-x-1 lg:space-x-2 px-2 py-2 lg:px-3 lg:py-2 text-blue-600 bg-blue-50 rounded-lg hover:bg-blue-100 transition-colors text-xs sm:text-sm lg:text-base whitespace-nowrap"
                >
                  <i className="ri-home-line"></i>
                  <span>Início</span>
                </button>
                <button 
                  onClick={() => navigate('/coimep')}
                  className="flex items-center justify-center space-x-1 lg:space-x-2 px-2 py-2 lg:px-3 lg:py-2 text-gray-600 hover:text-blue-600 hover:bg-blue-50 rounded-lg transition-colors text-xs sm:text-sm lg:text-base whitespace-nowrap"
                >
                  <i className="ri-building-line"></i>
                  <span>COIMEP</span>
                </button>
                <button 
                  onClick={() => navigate('/bible')}
                  className="flex items-center justify-center space-x-1 lg:space-x-2 px-2 py-2 lg:px-3 lg:py-2 text-gray-600 hover:text-blue-600 hover:bg-blue-50 rounded-lg transition-colors text-xs sm:text-sm lg:text-base whitespace-nowrap"
                >
                  <i className="ri-book-line"></i>
                  <span>Bíblia</span>
                </button>
                <button 
                  onClick={() => navigate('/characters')}
                  className="flex items-center justify-center space-x-1 lg:space-x-2 px-2 py-2 lg:px-3 lg:py-2 text-gray-600 hover:text-blue-600 hover:bg-blue-50 rounded-lg transition-colors text-xs sm:text-sm lg:text-base whitespace-nowrap"
                >
                  <i className="ri-user-star-line"></i>
                  <span>Personagens</span>
                </button>
                <button 
                  onClick={() => navigate('/devotionals')}
                  className="flex items-center justify-center space-x-1 lg:space-x-2 px-2 py-2 lg:px-3 lg:py-2 text-gray-600 hover:text-blue-600 hover:bg-blue-50 rounded-lg transition-colors text-xs sm:text-sm lg:text-base whitespace-nowrap"
                >
                  <i className="ri-heart-line"></i>
                  <span>Devocionais</span>
                </button>
                <button 
                  onClick={() => navigate('/studies')}
                  className="flex items-center justify-center space-x-1 lg:space-x-2 px-2 py-2 lg:px-3 lg:py-2 text-gray-600 hover:text-blue-600 hover:bg-blue-50 rounded-lg transition-colors text-xs sm:text-sm lg:text-base whitespace-nowrap"
                >
                  <i className="ri-graduation-cap-line"></i>
                  <span>Estudos</span>
                </button>
                <button 
                  onClick={() => navigate('/radio')}
                  className="flex items-center justify-center space-x-1 lg:space-x-2 px-2 py-2 lg:px-3 lg:py-2 text-gray-600 hover:text-blue-600 hover:bg-blue-50 rounded-lg transition-colors text-xs sm:text-sm lg:text-base whitespace-nowrap"
                >
                  <i className="ri-radio-line"></i>
                  <span>Rádio</span>
                </button>
                <button 
                  onClick={() => navigate('/kids')}
                  className="flex items-center justify-center space-x-1 lg:space-x-2 px-2 py-2 lg:px-3 lg:py-2 text-gray-600 hover:text-blue-600 hover:bg-blue-50 rounded-lg transition-colors text-xs sm:text-sm lg:text-base whitespace-nowrap"
                >
                  <i className="ri-bear-smile-line"></i>
                  <span>Crianças</span>
                </button>
                <button 
                  onClick={() => navigate('/prayer-requests')}
                  className="flex items-center justify-center space-x-1 lg:space-x-2 px-2 py-2 lg:px-3 lg:py-2 text-gray-600 hover:text-blue-600 hover:bg-blue-50 rounded-lg transition-colors text-xs sm:text-sm lg:text-base whitespace-nowrap"
                >
                  <i className="ri-hands-line"></i>
                  <span>Oração</span>
                </button>
                <button 
                  onClick={() => navigate('/filiais')}
                  className="flex items-center space-x-1 lg:space-x-2 px-2 py-2 lg:px-3 lg:py-2 text-gray-600 hover:text-green-600 hover:bg-green-50 rounded-lg transition-colors text-xs sm:text-sm lg:text-base whitespace-nowrap"
                >
                  <i className="ri-building-2-line"></i>
                  <span>Filiais</span>
                </button>
                <button 
                  onClick={() => navigate('/location')}
                  className="flex items-center space-x-1 lg:space-x-2 px-2 py-2 lg:px-3 lg:py-2 text-gray-600 hover:text-green-600 hover:bg-green-50 rounded-lg transition-colors text-xs sm:text-sm lg:text-base whitespace-nowrap"
                >
                  <i className="ri-map-pin-line"></i>
                  <span>Localização</span>
                </button>
              </div>
            </nav>
          </div>
        </div>
      </header>

      {/* Hero Section Responsivo */}
      <div className="relative h-64 sm:h-80 lg:h-96 bg-gradient-to-r from-blue-600 via-purple-600 to-indigo-600 overflow-hidden">
        <div className="absolute inset-0 bg-black/30"></div>
        <img 
          src="https://public.readdy.ai/ai/img_res/652ddce41bdad617c5066ce80d5f0ed3.jpg"
          alt="COIMEP - Convenção Internacional"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 flex items-center justify-center px-4">
          <div className="text-center text-white max-w-4xl">
            <h2 className="text-2xl sm:text-3xl lg:text-5xl font-bold mb-2 lg:mb-4">Bem-vindo à COIMEP</h2>
            <p className="text-sm sm:text-lg lg:text-xl mb-2 lg:mb-4 opacity-90">
              Convenção Internacional de Igrejas e Ministros de Culto da Europa
            </p>
            <p className="text-xs sm:text-base lg:text-lg mb-4 lg:mb-8 opacity-85">
              "Unindo ministérios, edificando o Reino de Deus" - Fundada em 2021
            </p>
            <div className="flex flex-wrap justify-center gap-2 lg:gap-4">
              <button 
                onClick={() => navigate('/bible')}
                className="bg-white text-blue-600 px-4 py-2 lg:px-8 lg:py-4 rounded-lg font-semibold hover:bg-blue-50 transition-colors text-xs sm:text-sm lg:text-base whitespace-nowrap"
              >
                Ler a Bíblia
              </button>
              <button 
                onClick={() => navigate('/coimep')}
                className="bg-blue-600 text-white px-4 py-2 lg:px-8 lg:py-4 rounded-lg font-semibold hover:bg-blue-700 transition-colors border-2 border-white text-xs sm:text-sm lg:text-base whitespace-nowrap"
              >
                Conhecer a COIMEP
              </button>
              <button 
                onClick={() => navigate('/devotionals')}
                className="bg-purple-600 text-white px-4 py-2 lg:px-8 lg:py-4 rounded-lg font-semibold hover:bg-purple-700 transition-colors border-2 border-white text-xs sm:text-sm lg:text-base whitespace-nowrap"
              >
                Devocional de Hoje
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* COIMEP Presentation Section Responsivo */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-8 lg:py-16">
        <div className="text-center mb-8 lg:mb-12">
          <h3 className="text-2xl lg:text-3xl font-bold text-white mb-2 lg:mb-4">Apresentação Institucional</h3>
          <p className="text-lg lg:text-xl text-white/90">Conhecendo a COIMEP</p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 lg:gap-8 mb-8 lg:mb-16">
          {/* About COIMEP */}
          <div className="bg-white/95 backdrop-blur-sm rounded-2xl shadow-2xl p-6 lg:p-8 border border-white/20">
            <div className="w-12 h-12 lg:w-16 lg:h-16 bg-gradient-to-r from-blue-500 to-purple-500 rounded-full flex items-center justify-center mb-4 lg:mb-6 mx-auto">
              <i className="ri-building-line text-2xl lg:text-3xl text-white"></i>
            </div>
            <h4 className="text-lg lg:text-xl font-bold bg-gradient-to-r from-blue-600 to-purple-600 bg-clip-text text-transparent mb-3 lg:mb-4 text-center">Nossa História</h4>
            <p className="text-sm lg:text-base text-gray-700 leading-relaxed mb-3 lg:mb-4">
              A COIMEP foi fundada no ano de 2021, em Portugal, com o propósito de unir igrejas, pastores, obreiros e ministros que servem a Deus com integridade, amor e fidelidade ao Evangelho de Cristo.
            </p>
            <p className="text-sm lg:text-base text-gray-700 leading-relaxed">
              Hoje, a COIMEP possui sedes ativas em Portugal, Itália e Brasil, sustentada pelos colaboradores e ministérios filiados que, pela fé, mantêm viva a obra de Deus em diversos países.
            </p>
          </div>

          {/* Mission */}
          <div className="bg-white/95 backdrop-blur-sm rounded-2xl shadow-2xl p-6 lg:p-8 border border-white/20">
            <div className="w-12 h-12 lg:w-16 lg:h-16 bg-gradient-to-r from-purple-500 to-pink-500 rounded-full flex items-center justify-center mb-4 lg:mb-6 mx-auto">
              <i className="ri-heart-line text-2xl lg:text-3xl text-white"></i>
            </div>
            <h4 className="text-lg lg:text-xl font-bold bg-gradient-to-r from-purple-600 to-pink-600 bg-clip-text text-transparent mb-3 lg:mb-4 text-center">Nossa Missão</h4>
            <p className="text-sm lg:text-base text-gray-700 leading-relaxed mb-3 lg:mb-4">
              A convenção tem como missão fortalecer o corpo de Cristo, promover a comunhão entre os ministérios e garantir que cada igreja filiada caminhe em unidade doutrinária, ética e espiritual.
            </p>
            <p className="text-sm lg:text-base text-gray-700 leading-relaxed">
              Conforme os princípios estabelecidos em nosso Estatuto, buscamos a excelência no serviço ao Senhor.
            </p>
          </div>
        </div>

        {/* Biblical Verses Section Responsivo */}
        <div className="bg-gradient-to-r from-blue-600/90 to-purple-600/90 backdrop-blur-sm rounded-2xl p-6 lg:p-8 mb-8 lg:mb-16 text-white">
          <h4 className="text-xl lg:text-2xl font-bold text-center mb-6 lg:mb-8">Versículos que nos Inspiram</h4>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4 lg:gap-6">
            <div className="text-center">
              <p className="text-sm lg:text-lg mb-2">"E tudo quanto fizerdes, fazei-o de todo o coração, como ao Senhor, e não aos homens."</p>
              <p className="text-xs lg:text-sm opacity-90">Colossenses 3:23</p>
            </div>
            <div className="text-center">
              <p className="text-sm lg:text-lg mb-2">"Ora, há diversidade de dons, mas o Espírito é o mesmo."</p>
              <p className="text-xs lg:text-sm opacity-90">1 Coríntios 12:4</p>
            </div>
            <div className="text-center">
              <p className="text-sm lg:text-lg mb-2">"Sede firmes e constantes, sempre abundantes na obra do Senhor."</p>
              <p className="text-xs lg:text-sm opacity-90">1 Coríntios 15:58</p>
            </div>
          </div>
        </div>

        {/* Leadership Section Responsivo */}
        <div className="bg-white/95 backdrop-blur-sm rounded-2xl shadow-2xl p-6 lg:p-8 mb-8 lg:mb-16 border border-white/20">
          <h4 className="text-xl lg:text-2xl font-bold bg-gradient-to-r from-blue-600 to-purple-600 bg-clip-text text-transparent text-center mb-6 lg:mb-8">Liderança</h4>
          <div className="text-center">
            <div className="w-16 h-16 lg:w-24 lg:h-24 bg-gradient-to-r from-blue-500 to-purple-500 rounded-full flex items-center justify-center mx-auto mb-4">
              <i className="ri-user-star-line text-2xl lg:text-4xl text-white"></i>
            </div>
            <h5 className="text-lg lg:text-xl font-bold text-gray-800 mb-2">Pastor Adauto Pinheiro</h5>
            <p className="text-purple-600 font-medium mb-4">Pastor Presidente em Portugal</p>
            <p className="text-sm lg:text-base text-gray-700 max-w-2xl mx-auto">
              Líder dedicado que conduz a COIMEP com sabedoria e amor, promovendo a unidade entre os ministérios e o crescimento espiritual de toda a convenção.
            </p>
          </div>
        </div>
      </div>

      {/* Features Section Responsivo */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-8 lg:py-16">
        <div className="text-center mb-8 lg:mb-12">
          <h3 className="text-2xl lg:text-3xl font-bold text-white mb-2 lg:mb-4">Recursos Disponíveis</h3>
          <p className="text-lg lg:text-xl text-white/90">Tudo que você precisa para crescer espiritualmente</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8">
          {/* Bíblia Completa */}
          <div className="bg-white/95 backdrop-blur-sm rounded-2xl shadow-2xl p-6 lg:p-8 hover:shadow-3xl transition-all duration-300 transform hover:scale-105 border border-white/20">
            <div className="w-12 h-12 lg:w-16 lg:h-16 bg-gradient-to-r from-blue-500 to-purple-500 rounded-full flex items-center justify-center mb-4 lg:mb-6 mx-auto">
              <i className="ri-book-open-line text-2xl lg:text-3xl text-white"></i>
            </div>
            <h4 className="text-lg lg:text-xl font-bold bg-gradient-to-r from-blue-600 to-purple-600 bg-clip-text text-transparent mb-3 lg:mb-4 text-center">Bíblia Completa</h4>
            <p className="text-sm lg:text-base text-gray-600 text-center mb-4 lg:mb-6">
              Acesse todos os 66 livros da Bíblia com navegação fácil entre Antigo e Novo Testamento
            </p>
            <button 
              onClick={() => navigate('/bible')}
              className="w-full bg-gradient-to-r from-blue-600 to-purple-600 text-white py-2 lg:py-3 rounded-lg font-medium hover:from-blue-700 hover:to-purple-700 transition-colors text-sm lg:text-base whitespace-nowrap"
            >
              Explorar Bíblia
            </button>
          </div>

          {/* Personagens Bíblicos */}
          <div className="bg-white/95 backdrop-blur-sm rounded-2xl shadow-2xl p-6 lg:p-8 hover:shadow-3xl transition-all duration-300 transform hover:scale-105 border border-white/20">
            <div className="w-12 h-12 lg:w-16 lg:h-16 bg-gradient-to-r from-indigo-500 to-pink-500 rounded-full flex items-center justify-center mb-4 lg:mb-6 mx-auto">
              <i className="ri-user-star-line text-2xl lg:text-3xl text-white"></i>
            </div>
            <h4 className="text-lg lg:text-xl font-bold bg-gradient-to-r from-indigo-600 to-pink-600 bg-clip-text text-transparent mb-3 lg:mb-4 text-center">Personagens Bíblicos</h4>
            <p className="text-sm lg:text-base text-gray-600 text-center mb-4 lg:mb-6">
              Conheça os heróis da fé e suas histórias inspiradoras de coragem e obediência
            </p>
            <button 
              onClick={() => navigate('/characters')}
              className="w-full bg-gradient-to-r from-indigo-600 to-pink-600 text-white py-2 lg:py-3 rounded-lg font-medium hover:from-indigo-700 hover:to-pink-700 transition-colors text-sm lg:text-base whitespace-nowrap"
            >
              Conhecer Heróis
            </button>
          </div>

          {/* Rádio Evangélica */}
          <div className="bg-white/95 backdrop-blur-sm rounded-2xl shadow-2xl p-6 lg:p-8 hover:shadow-3xl transition-all duration-300 transform hover:scale-105 border border-white/20">
            <div className="w-12 h-12 lg:w-16 lg:h-16 bg-gradient-to-r from-purple-500 to-pink-500 rounded-full flex items-center justify-center mb-4 lg:mb-6 mx-auto">
              <i className="ri-radio-line text-2xl lg:text-3xl text-white"></i>
            </div>
            <h4 className="text-lg lg:text-xl font-bold bg-gradient-to-r from-purple-600 to-pink-600 bg-clip-text text-transparent mb-3 lg:mb-4 text-center">Rádio Evangélica</h4>
            <p className="text-sm lg:text-base text-gray-600 text-center mb-4 lg:mb-6">
              Ouça música gospel e pregações 24 horas por dia, onde quer que esteja
            </p>
            <button 
              onClick={() => navigate('/radio')}
              className="w-full bg-gradient-to-r from-purple-600 to-pink-600 text-white py-2 lg:py-3 rounded-lg font-medium hover:from-purple-700 hover:to-pink-700 transition-colors text-sm lg:text-base whitespace-nowrap"
            >
              Ouvir Rádio
            </button>
          </div>

          {/* Devocionais Diários */}
          <div className="bg-white/95 backdrop-blur-sm rounded-2xl shadow-2xl p-6 lg:p-8 hover:shadow-3xl transition-all duration-300 transform hover:scale-105 border border-white/20">
            <div className="w-12 h-12 lg:w-16 lg:h-16 bg-gradient-to-r from-green-500 to-blue-500 rounded-full flex items-center justify-center mb-4 lg:mb-6 mx-auto">
              <i className="ri-heart-line text-2xl lg:text-3xl text-white"></i>
            </div>
            <h4 className="text-lg lg:text-xl font-bold bg-gradient-to-r from-green-600 to-blue-600 bg-clip-text text-transparent mb-3 lg:mb-4 text-center">365 Devocionais</h4>
            <p className="text-sm lg:text-base text-gray-600 text-center mb-4 lg:mb-6">
              Um devocional para cada dia do ano com reflexões, orações e aplicações práticas
            </p>
            <button 
              onClick={() => navigate('/devotionals')}
              className="w-full bg-gradient-to-r from-green-600 to-blue-600 text-white py-2 lg:py-3 rounded-lg font-medium hover:from-green-700 hover:to-blue-700 transition-colors text-sm lg:text-base whitespace-nowrap"
            >
              Devocional de Hoje
            </button>
          </div>

          {/* Estudos Bíblicos */}
          <div className="bg-white/95 backdrop-blur-sm rounded-2xl shadow-2xl p-6 lg:p-8 hover:shadow-3xl transition-all duration-300 transform hover:scale-105 border border-white/20">
            <div className="w-12 h-12 lg:w-16 lg:h-16 bg-gradient-to-r from-orange-500 to-red-500 rounded-full flex items-center justify-center mb-4 lg:mb-6 mx-auto">
              <i className="ri-graduation-cap-line text-2xl lg:text-3xl text-white"></i>
            </div>
            <h4 className="text-lg lg:text-xl font-bold bg-gradient-to-r from-orange-600 to-red-600 bg-clip-text text-transparent mb-3 lg:mb-4 text-center">Estudos Profundos</h4>
            <p className="text-sm lg:text-base text-gray-600 text-center mb-4 lg:mb-6">
              Estudos versículo por versículo com comentários e aplicações para os dias atuais
            </p>
            <button 
              onClick={() => navigate('/studies')}
              className="w-full bg-gradient-to-r from-orange-600 to-red-600 text-white py-2 lg:py-3 rounded-lg font-medium hover:from-orange-700 hover:to-red-700 transition-colors text-sm lg:text-base whitespace-nowrap"
            >
              Iniciar Estudos
            </button>
          </div>

          {/* Área Kids */}
          <div className="bg-white/95 backdrop-blur-sm rounded-2xl shadow-2xl p-6 lg:p-8 hover:shadow-3xl transition-all duration-300 transform hover:scale-105 border border-white/20">
            <div className="w-12 h-12 lg:w-16 lg:h-16 bg-gradient-to-r from-yellow-500 to-orange-500 rounded-full flex items-center justify-center mb-4 lg:mb-6 mx-auto">
              <i className="ri-bear-smile-line text-2xl lg:text-3xl text-white"></i>
            </div>
            <h4 className="text-lg lg:text-xl font-bold bg-gradient-to-r from-yellow-600 to-orange-600 bg-clip-text text-transparent mb-3 lg:mb-4 text-center">Área Kids</h4>
            <p className="text-sm lg:text-base text-gray-600 text-center mb-4 lg:mb-6">
              Jogos, histórias e atividades bíblicas especialmente criadas para as crianças
            </p>
            <button 
              onClick={() => navigate('/kids')}
              className="w-full bg-gradient-to-r from-yellow-600 to-orange-600 text-white py-2 lg:py-3 rounded-lg font-medium hover:from-yellow-700 hover:to-orange-700 transition-colors text-sm lg:text-base whitespace-nowrap"
            >
              Diversão Kids
            </button>
          </div>
        </div>
      </div>

      {/* Stats Section Responsivo */}
      <div className="bg-gradient-to-r from-blue-600/90 to-purple-600/90 backdrop-blur-sm py-8 lg:py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6">
          <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 lg:gap-8 text-center text-white">
            <div>
              <div className="text-2xl lg:text-4xl font-bold mb-1 lg:mb-2">2021</div>
              <div className="text-sm lg:text-lg opacity-90">Ano de Fundação</div>
            </div>
            <div>
              <div className="text-2xl lg:text-4xl font-bold mb-1 lg:mb-2">3</div>
              <div className="text-sm lg:text-lg opacity-90">Países (PT • IT • BR)</div>
            </div>
            <div>
              <div className="text-2xl lg:text-4xl font-bold mb-1 lg:mb-2">66</div>
              <div className="text-sm lg:text-lg opacity-90">Livros da Bíblia</div>
            </div>
            <div>
              <div className="text-2xl lg:text-4xl font-bold mb-1 lg:mb-2">24/7</div>
              <div className="text-sm lg:text-lg opacity-90">Rádio Online</div>
            </div>
          </div>
        </div>
      </div>

      {/* Message to Ministers Responsivo */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-8 lg:py-16">
        <div className="bg-white/95 backdrop-blur-sm rounded-2xl shadow-2xl p-6 lg:p-8 border border-white/20">
          <h3 className="text-xl lg:text-2xl font-bold bg-gradient-to-r from-blue-600 to-purple-600 bg-clip-text text-transparent text-center mb-6 lg:mb-8">
            Mensagem aos Pastores, Obreiros e Membros
          </h3>
          <div className="text-gray-700 leading-relaxed space-y-3 lg:space-y-4">
            <p className="text-center text-base lg:text-lg">
              Amados servos e servas do Senhor, graça e paz vos sejam multiplicadas!
            </p>
            <p className="text-sm lg:text-base">
              Vivemos tempos em que a fidelidade ao chamado de Deus é mais necessária do que nunca. O Senhor tem levantado homens e mulheres dispostos a servir com amor e dedicação, e é por meio de cada um de vocês que a obra de Deus avança nas nações.
            </p>
            <p className="text-sm lg:text-base">
              A COIMEP reconhece o valor de cada ministério e de cada servo que dedica sua vida à pregação do Evangelho. Unidos em fé, seguimos construindo uma obra sólida, pautada na verdade e na santidade da Palavra de Deus.
            </p>
            <div className="text-center mt-6 lg:mt-8">
              <p className="text-blue-600 font-semibold italic text-sm lg:text-base">
                "Andarão dois juntos, se não estiverem de acordo?" — Amós 3:3
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Footer Responsivo */}
      <footer className="bg-gray-900/95 backdrop-blur-sm text-white py-8 lg:py-12">
        <div className="max-w-7xl mx-auto px-4 sm:px-6">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 lg:gap-8">
            <div>
              <div className="flex items-center space-x-3 mb-4">
                <div className="w-8 h-8 lg:w-10 lg:h-10 bg-gradient-to-r from-blue-600 to-purple-600 rounded-full flex items-center justify-center">
                  <i className="ri-book-open-line text-white"></i>
                </div>
                <h4 className="text-lg lg:text-xl font-bold" style={{ fontFamily: '"Pacifico", serif' }}>
                  COIMEP
                </h4>
              </div>
              <p className="text-gray-300 mb-2 text-sm lg:text-base">
                Convenção Internacional de Igrejas e Ministros de Culto da Europa
              </p>
              <p className="text-gray-300 text-xs lg:text-sm">
                Fundada em 2021 | Sedes: Portugal • Itália • Brasil
              </p>
              <p className="text-blue-400 text-xs lg:text-sm mt-2 font-semibold">
                "Unindo ministérios, edificando o Reino de Deus"
              </p>
            </div>

            <div>
              <h5 className="text-base lg:text-lg font-semibold mb-4">Recursos</h5>
              <ul className="space-y-2 text-gray-300 text-sm lg:text-base">
                <li><button onClick={() => navigate('/coimep')} className="hover:text-white transition-colors">Sobre a COIMEP</button></li>
                <li><button onClick={() => navigate('/bible')} className="hover:text-white transition-colors">Bíblia Completa</button></li>
                <li><button onClick={() => navigate('/characters')} className="hover:text-white transition-colors">Personagens Bíblicos</button></li>
                <li><button onClick={() => navigate('/radio')} className="hover:text-white transition-colors">Rádio Evangélica</button></li>
                <li><button onClick={() => navigate('/kids')} className="hover:text-white transition-colors">Área Kids</button></li>
                <li><button onClick={() => navigate('/devotionals')} className="hover:text-white transition-colors">Devocionais Diários</button></li>
                <li><button onClick={() => navigate('/studies')} className="hover:text-white transition-colors">Estudos Bíblicos</button></li>
              </ul>
            </div>

            <div>
              <h5 className="text-base lg:text-lg font-semibold mb-4">Liderança</h5>
              <p className="text-gray-300 mb-2 text-sm lg:text-base">Pastor Adauto Pinheiro</p>
              <p className="text-gray-300 mb-4 text-sm lg:text-base">Pastor Presidente em Portugal</p>
              <div className="flex space-x-4">
                <button className="w-8 h-8 lg:w-10 lg:h-10 bg-blue-600 rounded-full flex items-center justify-center hover:bg-blue-700 transition-colors">
                  <i className="ri-facebook-fill"></i>
                </button>
                <button className="w-8 h-8 lg:w-10 lg:h-10 bg-blue-400 rounded-full flex items-center justify-center hover:bg-blue-500 transition-colors">
                  <i className="ri-twitter-fill"></i>
                </button>
                <button className="w-8 h-8 lg:w-10 lg:h-10 bg-red-600 rounded-full flex items-center justify-center hover:bg-red-700 transition-colors">
                  <i className="ri-youtube-fill"></i>
                </button>
              </div>
            </div>
          </div>

          <div className="border-t border-gray-700 mt-6 lg:mt-8 pt-6 lg:pt-8 text-center text-gray-300">
            <p className="text-xs lg:text-base">&copy; 2024 COIMEP - Convenção Internacional de Igrejas e Ministros de Culto da Europa. Todos os direitos reservados.</p>
            <p className="mt-2 text-xs lg:text-sm">
              <a href="https://readdy.ai/?origin=logo" className="hover:text-white transition-colors">Powered by Readdy</a>
            </p>
          </div>
        </div>
      </footer>
    </div>
  );
}
